import React from 'react';
import { shape, string } from 'prop-types';
import { reportToSegment, types, eventNames } from '@smartcar/morse';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import computerDark from '../../assets/images/computer-dark.svg';

import { Overlay } from '../../global-styles/components';

const UpgradeOverlay = ({ staticText }) => {
  const theme = useTheme();
  return (
    <Overlay>
      <Box
        sx={{
          maxWidth: '400px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 3,
          backgroundColor: theme.palette.warning.light,
          borderRadius: theme.border.radius,
          border: `1px solid ${theme.palette.warning.main}`,
        }}
      >
        <img src={computerDark} alt="" />
        <Typography variant="bold" marginTop={2}>
          {staticText.title}
        </Typography>
        <Typography variant="body2" marginTop={2} marginBottom={2} sx={{ textAlign: 'center' }}>
          {staticText.description}
        </Typography>
        <Link
          onClick={() => {
            reportToSegment(types.TRACK, eventNames.linkClicked, {
              section: 'article',
              style: 'cta primary',
              text: 'upsell (overview)',
              path: staticText.upgradeButton.path,
            });
          }}
          to={staticText.upgradeButton.path}
          className="button-link button-link--warning"
        >
          {staticText.upgradeButton.text}
        </Link>
      </Box>
    </Overlay>
  );
};

export default UpgradeOverlay;

UpgradeOverlay.propTypes = {
  staticText: shape({
    title: string.isRequired,
    description: string.isRequired,
    upgradeButton: shape({
      path: string.isRequired,
      text: string.isRequired,
    }).isRequired,
  }).isRequired,
};
